var _defs, _ellipse, _ellipse2, _ellipse3, _rect, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack1143({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 8,
    cy: 9.82,
    rx: 4.4,
    ry: 5.18
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 8,
    cy: 9.42,
    rx: 3.18,
    ry: 3.74
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 8,
    cy: 7.23,
    rx: 1.32,
    ry: 1.55
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 2.89,
    y: 1,
    width: 10.21,
    height: 3.18,
    rx: 0.4
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 4.45,
    y1: 4.18,
    x2: 4.45,
    y2: 6.63
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 11.55,
    y1: 4.18,
    x2: 11.55,
    y2: 6.63
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack1143);
export default __webpack_public_path__ + "static/media/Symbolpack_1_143.56bb77ce6fd01bef6595afec90b27e75.svg";
export { ForwardRef as ReactComponent };